import { useCurrency } from '@/context/CurrencyContext';

const PriceDisplay = ({ amount, className = '', primaryClass = '', secondaryClass = '', compact = true }) => {
  const { formatPrice, formatPriceAED } = useCurrency();
  const primary = formatPrice(amount, { compact });
  const secondary = formatPriceAED(amount, { compact });

  return (
    <span className={`inline-flex flex-col ${className}`}>
      <span className={primaryClass}>{primary}</span>
      {secondary && <span className={`text-text-secondary text-xs ${secondaryClass}`}>{secondary}</span>}
    </span>
  );
};

export default PriceDisplay;
